import { SEARCH_AGGREGATES } from '@/utils/constants'
import type { CheckboxOptionType } from 'antd'
import { Checkbox } from 'antd'
import { AggregateBucketModel, AggregatesValue } from '~types/search'

import { useEffect, useState } from 'react'

const FilterTags = ({
  buckets,
  defaultValue,
  onChange,
}: {
  buckets: AggregateBucketModel[]
  defaultValue: AggregatesValue
  onChange: (filter: string, value: string[]) => void
}) => {
  const [value, setValue] = useState<string[]>((defaultValue as string[]) ?? [])

  useEffect(() => {
    setValue((defaultValue as string[]) ?? [])
  }, [defaultValue])

  const handleChange = (value: string[]) => {
    setValue(value)
    onChange(SEARCH_AGGREGATES.tags, value)
  }

  const options: CheckboxOptionType<string>[] = buckets.map((item) => ({
    value: item.key,
    label: `${item.key} (${item.docCount})`,
  }))

  return (
    <Checkbox.Group
      className="filter-aggregate filter-aggregate-tags"
      value={value}
      options={options}
      onChange={handleChange}
    />
  )
}

export default FilterTags
